import { accessRole } from "../../../../helpers/access_role"
import ErrorAccess from "../../../../components/Error/Content/Access"
import IndexComponent from "./Components/IndexComponent"
import TeamComponent from "./Components/TeamComponent"
import MemberComponent from "./Components/MemberComponent"

const RouteView = (props) => {

   const queryParams = new URLSearchParams(props.location.search);
   const section = queryParams.get('section')

   if(section !== undefined && section !== null){

      if(section === 'team'){
         return accessRole('create') ? <TeamComponent /> : <ErrorAccess />
      }

      if(section === 'member'){
         return accessRole('create') ? <MemberComponent /> : <ErrorAccess />
      }

   }

   return accessRole('read') ? <IndexComponent /> : <ErrorAccess />
}
export default RouteView